var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47327 0 0 4.4725 0 10C0 15.5267 4.4725 20 10 20C15.5267 20 20 15.5275 20 10C20 4.47327 15.5275 0 10 0ZM10 18.4375C5.33676 18.4375 1.5625 14.6637 1.5625 10C1.5625 5.33676 5.3363 1.5625 10 1.5625C14.6632 1.5625 18.4375 5.3363 18.4375 10C18.4375 14.6632 14.6637 18.4375 10 18.4375ZM12.3177 14.6094C12.3177 15.0409 11.9679 15.3906 11.5364 15.3906H8.46359C8.03207 15.3906 7.68234 15.0409 7.68234 14.6094C7.68234 14.1779 8.03207 13.8281 8.46359 13.8281H9.21875V9.24484H8.46359C8.03207 9.24484 7.68234 8.89511 7.68234 8.46359C7.68234 8.03207 8.03207 7.68234 8.46359 7.68234H10C10.4315 7.68234 10.7812 8.03207 10.7812 8.46359V13.8281H11.5364C11.9679 13.8281 12.3177 14.1779 12.3177 14.6094ZM9.02344 4.83078C9.02344 4.29138 9.4606 3.85422 10 3.85422C10.5394 3.85422 10.9766 4.29138 10.9766 4.83078C10.9766 5.37003 10.5394 5.80734 10 5.80734C9.4606 5.80734 9.02344 5.37003 9.02344 4.83078Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.4e0cdfccb2b17f7705fa902820931940.svg";
export { ForwardRef as ReactComponent };